import React from 'react';
import { Draggable } from './Draggable';
import { VariablesEnum } from '../const';

export type DraggableListProps = {
  items: string[];
  type: VariablesEnum.variables | VariablesEnum.prompts;
  promptData?: Array<{ id: string; title: string }>;
};

export const DraggableList: React.FC<DraggableListProps> = ({
  items,
  type,
  promptData = [],
}) => {
  const getDropValue = (item: string, index: number) => {
    if (type === VariablesEnum.variables) {
      return `{${item}}`;
    } else if (type === VariablesEnum.prompts) {
      const prompt = promptData[index];
      return prompt && prompt.id ? `$[${prompt.id}]` : `$${item}`;
    }
    return item;
  };

  const getDisplayValue = (item: string, index: number) => {
    if (type === VariablesEnum.variables) {
      return item;
    } else if (type === VariablesEnum.prompts) {
      const prompt = promptData[index];
      return prompt && prompt.title ? prompt.title : item;
    }
    return item;
  };

  return (
    <div className="flex-1 overflow-y-auto min-h-0">
      {items.map((item, index) => (
        <Draggable
          key={item}
          id={getDropValue(item, index)}
          dragPreviewStyle={{
            backgroundColor:
              type === VariablesEnum.variables ? '#f3f4f6' : '#e0e7ff',
            border:
              type === VariablesEnum.variables
                ? '1px solid #d1d5db'
                : '1px solid #a5b4fc',
            borderRadius: '6px',
            padding: '4px 8px',
            fontSize: '12px',
            fontFamily: 'monospace',
          }}
        >
          {getDisplayValue(item, index)}
        </Draggable>
      ))}
    </div>
  );
};
